import { useTranslations } from '@vocab/react';
import { Textarea } from 'braid-design-system';
import type { QuestionProps } from '../../type';
import { GOOD_THINGS_MAX_LENGTH } from '../../validation/validationRules';
import translations from './.vocab';

export const TheGoodThingsQuestion = ({
  value = '',
  message = '',
  tone,
  onChange,
}: QuestionProps) => {
  const { t } = useTranslations(translations);
  return (
    <Textarea
      id={'theGoodThings'}
      label={t('The good things')}
      description={t('Describe what you like the most')}
      onChange={(event) => onChange(event.currentTarget.value)}
      value={value}
      tone={tone}
      message={message}
      reserveMessageSpace
      characterLimit={GOOD_THINGS_MAX_LENGTH}
    />
  );
};
